import React from "react"
import { Switch } from "~/ui/primitives"
import { useTheme } from "~/ui/styled"
import { Text, IconFont, StartFlex } from "~components/El"
import { SettingSuffix } from "../types"

const RenderSuffix: React.FC<{suffix?: SettingSuffix}> = ({ suffix }) => {
  const theme = useTheme()
  if (!suffix) return null
  if (suffix?.value === "") return null
  switch (suffix.type) {
    case "text":
      return (
        <StartFlex>
          <Text
            fontSize={theme.fontSizes.sm}
            color={theme.colors.infoText}
            mr="8px"
          >
            {suffix.value}
          </Text>
          <IconFont name="right" size={12} color={theme.colors.secondary} />
        </StartFlex>
      )

    case "switch":
      return (
        <Switch
          value={suffix.value}
          onValueChange={suffix.onChange}
          disabled={suffix.disabled}
        />
      )

    default:
      return null
  }
}

export default RenderSuffix
